import React from 'react';
import { Page } from 'hedron';
import containerWidth from 'common/consts/containerWidth';

const Container = props => (
  <Page {...props} width={`${containerWidth}px`} />
);

export default Container;



// WEBPACK FOOTER //
// ./src/blocks/Container/Container.jsx